import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'raccordo';
export const ENTITY_PLURAL = 'raccordo';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Prospetto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.prospetto.descrizione',
    sortable: true,
  },
  {
    elementLabel: 'Lettera',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.lettera',
    sortable: true,
    minWidth: 110,
    maxWidth: 110,
  },
  {
    elementLabel: 'Rif. 1',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.rif1',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Rif. 2',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.rif2',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Rif. 3',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.rif3',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Rif. 4',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.rif4',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Struttura',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.descrizione',
    sortable: true,
  },
  {
    elementLabel: 'Codice Piano dei Conti',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.codice',
  },
  {
    elementLabel: 'Piano dei Conti',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.descrizione',
  },
  {
    elementLabel: 'Tipo',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.tipo',
  },
  {
    elementLabel: 'Esercizio',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'esercizio',
    initialHideColumn: true,
    exportHideColumn: false,
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;
export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
